import Box from '@mui/material/Box'

import Typography from '@mui/material/Typography'

import FormCreator from '@/shared/FormCreator'
import { forwardRef, useImperativeHandle, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import * as Yup from 'yup'

const inputConfig = {
  variant: 'standard',
  inputBaseProps: {
    labelSuffix: '',
    flexDirection: 'column',
    alignItems: 'stretch',
    spacing: 0,
    labelProps: { sx: { color: theme => theme.palette.btn_positive.main } },
  },
  color: 'btn_positive',
  endAdornment: args => {
    const {
      value,
      inputProps: { maxLength },
    } = args
    return (
      <Typography
        variant="caption"
        sx={{ color: '#00000040', fontSize: '14px !important' }}
      >{`${value.length}/${maxLength}`}</Typography>
    )
  },
}

const EditRegisteredUserCard = forwardRef(({ data }, ref) => {
  const form = useRef()
  const { t } = useTranslation()
  const { cname, companyName, dept, deptGroup, email, firstName, lastName, position, phone } =
    data || {}

  useImperativeHandle(ref, () => form.current)

  return (
    <Box
      sx={{
        mb: 2,
      }}
    >
      <FormCreator
        ref={form}
        gridItemProps={{ md: 2.4 }}
        formItems={[
          {
            label: t('general.company_name'),
            name: 'companyName',
            defaultValue: companyName || '',
            inputConfig: { ...inputConfig, inputProps: { maxLength: 20 } },
          },
          {
            label: `*${t('general.email')}`,
            name: 'email',
            gridProps: { md: 4.8 },
            validator: Yup.string()
              .required(t('validation.email_required'))
              .email(t('validation.email_format')),
            defaultValue: email || '',
            inputConfig: {
              ...inputConfig,
              inputProps: { maxLength: 40 },
              inputBaseProps: {
                ...inputConfig.inputBaseProps,
                labelSuffix: (
                  <Typography sx={{ color: theme => theme.palette.primary.main, ml: 1 }}>{`(${t(
                    'general.required',
                  )})`}</Typography>
                ),
              },
            },
          },
          {
            label: t('general.phone'),
            name: 'phone',
            defaultValue: phone || '',
            validator: Yup.string()
              .matches(/^(09\d{8})?$/, t('validation.phone_ten_digits_start_zero_nine'))
              .test('check-starting-digits', 'Phone number must start with "09"', value => {
                if (!value) return true
                return value.startsWith('09')
              })
              .test('check-number-length', 'Phone number must have exactly 10 digits', value => {
                if (!value) return true
                return value.replace(/[^0-9]/g, '').length === 10
              }),
            inputConfig: { ...inputConfig, inputProps: { maxLength: 10 } },
          },

          {
            label: t('general.last_name'),
            name: 'lastName',
            defaultValue: lastName || '',
            inputConfig: { ...inputConfig, inputProps: { maxLength: 10 } },
          },
          {
            label: t('general.first_name'),
            name: 'firstName',
            defaultValue: firstName || '',
            inputConfig: { ...inputConfig, inputProps: { maxLength: 10 } },
          },
          {
            label: t('general.name'),
            name: 'cname',
            defaultValue: cname || '',
            inputConfig: { ...inputConfig, inputProps: { maxLength: 10 } },
          },
          {
            label: t('general.business_group'),
            name: 'deptGroup',
            defaultValue: deptGroup || '',
            inputConfig: { ...inputConfig, inputProps: { maxLength: 10 } },
          },
          {
            label: t('general.department_name'),
            name: 'dept',
            defaultValue: dept || '',
            inputConfig: { ...inputConfig, inputProps: { maxLength: 10 } },
          },
          {
            label: t('general.position'),
            name: 'position',
            defaultValue: position || '',
            inputConfig: { ...inputConfig, inputProps: { maxLength: 20 } },
          },
        ]}
        flexDirection="row"
        submitComponent={() => null}
        resetComponent={() => null}
      />
    </Box>
  )
})

export default EditRegisteredUserCard
